import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from 'app/types/entity';
import { Section, ISection } from 'app/constants/schemas/Section';
import { associations, attributes, IAttributes, IAssociations } from './mediaList';

type MediaSectionType = ISection & {
  attributes: IAttributes;
  associations: IAssociations;
};

export type MediaSection = Entity<MediaSectionType>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaSection: IEntityType<MediaSectionType> = vmClient.defineClass({
  typeName: 'MediaSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  attributes,
  associations,
});
